import { render, staticRenderFns } from "./LabelDetails.vue?vue&type=template&id=5a52411b&scoped=true"
import script from "./LabelDetails.vue?vue&type=script&lang=js"
export * from "./LabelDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a52411b",
  null
  
)

export default component.exports